[
    {
        "customerUuid": "bc1fa143-2be7-47ec-a5b2-dce616ab4fc9",
        "customerName": "Quantified",
        "accounts": [
            {
                "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
                "accountName": "Quantified"
            }
        ]
    }
]